import React, { useContext } from "react";
import CustomNavbar from "../components/CustomNavbar";
import Breadcrumb from "../components/Breadcrumb";
import ServiceDetails from "../components/Service/ServiceDetails";
import FooterTwo from "../components/Footer/FooterTwo";
import FooterData from "../components/Footer/FooterData";
import { ServiceDetailsContext } from "../store/ServiceDetailsContext";
import { Helmet } from "react-helmet";
// import { ServiceDetailsProvider as ServiceProvider } from "../store/ServiceDetailsContext";\

const Faq = ({ match }) => {
    const serviceDetailsCtx = useContext(ServiceDetailsContext);
    let title = "";
    let metaDescription = "";
    let metaKeywords = "";

    if (match.params.serviceName == "Cash-for-Old-Cars") {
        title = "Cash for Old Cars";
        metaDescription =
            "Our cash for old cars service easily provides you cash for your old or damaged cars.";
        metaKeywords = "Cash for Old Cars";
    } else if (match.params.serviceName == "Cash-for-Junk-Cars") {
        title = "Cash for Junk Cars";
        metaDescription =
            "If you have a junk car, truck, van, SUV, or any other vehicle you need to make a call to us.";
        metaKeywords = "Cash for Junk Cars";
    } else if (match.params.serviceName == "Sell-Hail-Damaged-Car") {
        title = "Sell Hail Damaged Car";
        metaDescription =
            "Our Car Wreckers team will give you a quote and cash immediately. Crew of professional Rapid Cash for Cars specialists is highly efficient.";
        metaKeywords = "Sell Hail Damaged Car";
    } else if (match.params.serviceName == "Cash-for-Scrap-Cars") {
        title = "Cash for Scrap Cars";
        metaDescription =
            "In case the vehicle is not too old but is damaged by any crash, it is quite hard to sell it to a prospective customer. Keeping an extremely old and damaged car may be an eyesore for your neighbors.";
        metaKeywords = "Cash for Scrap Cars";
    } else if (match.params.serviceName == "Recycle-Junk-Car") {
        title = "Recycle Junk Car";
        metaDescription =
            "We are swollen with pride to mention here the characteristics of our scrap car removal team.";
        metaKeywords = "Recycle Junk Car";
    } else if (match.params.serviceName == "Sell-Used-Car-Easily") {
        title = "Sell Used Car Easily";
        metaDescription =
            "We are a scrap car removal service provider that not only accepts and remove old and unwanted cars. You can sell your used cars to us easily";
        metaKeywords = "Sell Used Car Easily";
    } else if (match.params.serviceName == "Free-Car-Removal") {
        title = "Free Car Removal ";
        metaDescription =
            "We are a free scrap car removal service provider that not only accepts and remove old and unwanted cars.";
        metaKeywords = "Free Car Removal";
    } else if (match.params.serviceName == "Old-Car-Removal") {
        title = "Old Car Removal ";
        metaDescription =
            "We are a old car removal service provider that not only accepts and remove old and unwanted cars.";
        metaKeywords = "Old Car Removal";
    } else if (match.params.serviceName == "Scrap-Car-Removal") {
        title = "Scrap Car Removal";
        metaDescription =
            "We are a scrap car removal service provider that not only accepts and remove old and unwanted cars.";
        metaKeywords = "Scrap Car Removal";
    } else if (match.params.serviceName == "Sell-Used-Trucks") {
        title = "Sell Used Trucks";
        metaDescription =
            "We are a scrap car removal service provider that not only accepts and remove old and unwanted cars but also sell used trucks.";
        metaKeywords = "Sell Used Trucks";
    } else if (match.params.serviceName == "Sell-Used-Vans") {
        title = "Sell Used Vans";
        metaDescription =
            "We are a scrap car removal service provider that not only accepts and remove old and unwanted cars but also sell and accept used vans.";
        metaKeywords = "Sell Used Vans";
    } else if (match.params.serviceName == "Sell-Used-Cars") {
        title = "Sell Used Cars";
        metaDescription =
            "We are a scrap car removal service provider that not only accepts and remove old and unwanted cars but also sell and accept used cars.";
        metaKeywords = "Sell Used Cars";
    }

    return (
        <div className="body_wrapper">
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={metaDescription} />
                <meta name="keywords" content={metaKeywords} />
            </Helmet>

            <CustomNavbar
                slogo="sticky_logo"
                cClass="custom_container p0"
                mClass="menu_four"
                nClass="w_menu"
            />
            {/* <CustomNavbar slogo="sticky_logo" cClass="custom_container p0" mClass="menu_four" nClass="w_menu ml-auto mr-auto" /> */}
            {/* <ServiceProvider> */}
            <Breadcrumb
                breadcrumbClass="breadcrumb_area"
                imgName="Img-05.jpg"
                Pdescription="Why I say old chap that is spiffing off his nut arse pear shaped plastered Jeffrey bodge barney some dodgy.!!"
                // padding="0px"
                Ptitle={match.params.serviceName}
            />
            {/* </ServiceProvider> */}
            <ServiceDetails
                title={match.params.serviceName}
                icon={match.params.serviceImage}
            />
            <FooterTwo FooterData={FooterData} />
        </div>
    );
};
export default Faq;
